<nav class="erp-topbar">
  <div class="erp-topbar-inner">

    <!-- Brand -->
    <a class="erp-brand" routerLink="/">
      <img
        alt="Mavles"
        src="assets/media/logos/mavles/mavles-logo-letter.png"
        height="30"
      />
    </a>

    <!-- App / Module Launcher Dropdown -->
    <div class="dropdown erp-app-launcher d-none d-md-block">
      <button
        class="erp-icon-btn"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title="Modules & Apps"
      >
        <i class="bi bi-grid-3x3-gap-fill fs-6"></i>
      </button>
      <div class="dropdown-menu shadow-lg p-3 erp-launcher-dropdown">
        <div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
          <span class="fs-7 fw-bold text-uppercase text-muted">All ERP Modules</span>
          <span class="badge bg-secondary-subtle text-secondary fs-9">Mavles Core</span>
        </div>
        <div class="row g-2 erp-launcher-grid">
          <div class="col-4">
            <a routerLink="/order/invoice/view-all" class="erp-module-tile">
              <i class="bi bi-receipt text-primary"></i>
              <span>Sales</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/order/purchase/view-all" class="erp-module-tile">
              <i class="bi bi-bag-check text-warning"></i>
              <span>Purchase</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/accounts/transaction/view-all" class="erp-module-tile">
              <i class="bi bi-cash-stack text-success"></i>
              <span>Payments</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/accounts/wallet" class="erp-module-tile">
              <i class="bi bi-wallet2 text-info"></i>
              <span>Wallets</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/work" class="erp-module-tile">
              <i class="bi bi-hammer text-danger"></i>
              <span>Work</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/hrm/customer/view-all" class="erp-module-tile">
              <i class="bi bi-people text-primary"></i>
              <span>Contacts</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/dashboard/supervisor" class="erp-module-tile">
              <i class="bi bi-speedometer2 text-info"></i>
              <span>Supervisor</span>
            </a>
          </div>
          <div class="col-4">
            <a routerLink="/hrm/reminders" class="erp-module-tile">
              <i class="bi bi-bell text-warning"></i>
              <span>Reminders</span>
            </a>
          </div>
          @if (isAdmin) {
            <div class="col-4">
              <a routerLink="/user-management" class="erp-module-tile">
                <i class="bi bi-shield-lock text-danger"></i>
                <span>Access</span>
              </a>
            </div>
          } @else {
            <div class="col-4">
              <a routerLink="/manage/tags/view-all" class="erp-module-tile">
                <i class="bi bi-tags text-secondary"></i>
                <span>Tags</span>
              </a>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="erp-topbar-divider d-none d-lg-block"></div>

    <!-- Global Search -->
    <div class="erp-global-search d-none d-lg-flex">
      <lib-contact-selector (contactSelected)="onContactChange($event)"></lib-contact-selector>
    </div>

    <!-- Spacer -->
    <div class="flex-grow-1"></div>

    <!-- Quick-nav links -->
    <ul class="erp-topbar-nav d-none d-xl-flex">
      <li>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
          <i class="bi bi-speedometer2"></i>
          <span>Dashboard</span>
        </a>
      </li>
      <li>
        <a routerLink="/dashboard/supervisor" routerLinkActive="active">
          <i class="bi bi-graph-up"></i>
          <span>Supervisor</span>
        </a>
      </li>
      <li>
        <a routerLink="/accounts/wallet" routerLinkActive="active">
          <i class="bi bi-wallet2"></i>
          <span>Wallets</span>
        </a>
      </li>
      @if (isAdmin) {
        <li>
          <a routerLink="/user-management" routerLinkActive="active">
            <i class="bi bi-people"></i>
            <span>Users</span>
          </a>
        </li>
      }
      <li>
        <a routerLink="/manage/tags/view-all" routerLinkActive="active">
          <i class="bi bi-tags"></i>
          <span>Tags</span>
        </a>
      </li>
    </ul>

    <!-- Reminders Quick Bell -->
    <a
      routerLink="/hrm/reminders"
      class="erp-icon-btn d-none d-md-flex"
      title="Reminders & Follow-Ups"
    >
      <i class="bi bi-bell fs-6"></i>
    </a>

    <!-- + Quick Create Dropdown -->
    <div class="dropdown erp-quick-create d-none d-sm-block">
      <button
        class="btn btn-sm btn-primary d-flex align-items-center gap-1.5 px-2.5 py-1.5 fw-semibold erp-create-btn"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="bi bi-plus-lg"></i>
        <span class="d-none d-md-inline">Create</span>
        <i class="bi bi-chevron-down fs-9 ms-1 opacity-75"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end shadow erp-create-dropdown">
        <li class="dropdown-header text-uppercase fs-9 fw-bold text-muted">Sales & Invoicing</li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="createInvoice()">
            <i class="bi bi-receipt text-primary me-2"></i>New Invoice
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="createEstimate()">
            <i class="bi bi-file-earmark-text text-info me-2"></i>New Estimate
          </a>
        </li>
        <li><hr class="dropdown-divider my-1"></li>
        <li class="dropdown-header text-uppercase fs-9 fw-bold text-muted">Payments & Expenses</li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="createExpense()">
            <i class="bi bi-cash-stack text-danger me-2"></i>Record Expense
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="createCustomerPayment()">
            <i class="bi bi-wallet2 text-success me-2"></i>Customer Payment
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="createPurchase()">
            <i class="bi bi-bag-plus text-warning me-2"></i>Purchase Order
          </a>
        </li>
        <li><hr class="dropdown-divider my-1"></li>
        <li class="dropdown-header text-uppercase fs-9 fw-bold text-muted">Contacts & Labour</li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="newCustomer()">
            <i class="bi bi-person-plus text-primary me-2"></i>New Customer
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="newVendor()">
            <i class="bi bi-truck text-warning me-2"></i>New Vendor
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="newLead()">
            <i class="bi bi-person-badge text-info me-2"></i>New Lead
          </a>
        </li>
        <li>
          <a class="dropdown-item py-1.5 cursor-pointer" (click)="newWorksheet()">
            <i class="bi bi-clipboard-plus text-secondary me-2"></i>Labour Worksheet
          </a>
        </li>
      </ul>
    </div>

    <div class="erp-topbar-divider d-none d-lg-block"></div>

    <!-- User Profile Dropdown -->
    <div class="dropdown erp-user-menu">
      <div class="erp-user-trigger" data-bs-toggle="dropdown" aria-expanded="false">
        <img
          [src]="mediaService.getURLByUUID(appService.currentUser?.image_id)"
          alt="user"
          class="erp-user-avatar"
        />
        <div class="erp-user-info d-none d-xl-block">
          <span class="erp-user-name">
            {{ appService.currentUser?.firstname }} {{ appService.currentUser?.lastname }}
          </span>
          <span class="erp-user-role">
            <i class="bi bi-shield-check text-primary me-1"></i>{{ currentRole }}
          </span>
        </div>
        <i class="bi bi-chevron-down erp-user-chevron d-none d-xl-block"></i>
      </div>

      <ul class="dropdown-menu dropdown-menu-end erp-profile-dropdown shadow">
        <li>
          <div class="erp-dropdown-header">
            <img
              [src]="mediaService.getURLByUUID(appService.currentUser?.image_id)"
              alt="avatar"
              class="erp-user-avatar-lg"
            />
            <div>
              <div class="erp-dropdown-name">
                {{ appService.currentUser?.firstname }} {{ appService.currentUser?.lastname }}
              </div>
              <span class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-2 py-0.5 fs-8 mb-1">
                <i class="bi bi-shield-check me-1"></i>{{ currentRole }}
              </span>
              @if (appService.currentUser?.email) {
                <div class="erp-dropdown-email">{{ appService.currentUser?.email }}</div>
              } @else {
                <div class="erp-dropdown-email text-warning">Configure your email</div>
              }
            </div>
          </div>
        </li>
        <li><hr class="dropdown-divider my-1" /></li>
        <li>
          <a class="dropdown-item" routerLink="/user-view" (click)="isProfileMenuOpen = false">
            <i class="bi bi-person me-2"></i> My Profile
          </a>
        </li>
        @if (isAdmin) {
          <li>
            <a class="dropdown-item" routerLink="/user-management" (click)="isProfileMenuOpen = false">
              <i class="bi bi-people me-2"></i> User Directory & Access
            </a>
          </li>
        }
        <li>
          <a class="dropdown-item" routerLink="/hrm/reminders" (click)="isProfileMenuOpen = false">
            <i class="bi bi-bell me-2"></i> Reminders Hub
          </a>
        </li>
        <li><hr class="dropdown-divider my-1" /></li>
        <li>
          <a
            class="dropdown-item text-danger"
            href="#"
            (click)="appService.signOut(); isProfileMenuOpen = false; $event.preventDefault()"
          >
            <i class="bi bi-box-arrow-right me-2"></i> Sign Out
          </a>
        </li>
      </ul>
    </div>

    <!-- Mobile toggle -->
    <button
      class="erp-mobile-toggle d-lg-none"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i class="bi bi-list fs-4"></i>
    </button>

  </div>

  <!-- Mobile collapse panel -->
  <div class="collapse erp-mobile-panel" id="navbarContent">
    <!-- Mobile User Banner -->
    <div class="d-flex align-items-center gap-2 p-3 pb-2 border-bottom border-secondary border-opacity-25">
      <img
        [src]="mediaService.getURLByUUID(appService.currentUser?.image_id)"
        alt="avatar"
        class="erp-user-avatar"
      />
      <div class="flex-grow-1">
        <div class="text-white fw-bold fs-7">
          {{ appService.currentUser?.firstname }} {{ appService.currentUser?.lastname }}
        </div>
        <span class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-2 py-0.5 fs-9">
          <i class="bi bi-shield-check me-1"></i>{{ currentRole }}
        </span>
      </div>
      <a class="btn btn-sm btn-outline-danger py-0.5 px-2 fs-8" (click)="appService.signOut()">
        <i class="bi bi-box-arrow-right"></i>
      </a>
    </div>

    <!-- Mobile Quick Actions -->
    <div class="p-3 pb-1 border-bottom border-secondary border-opacity-25">
      <div class="fs-8 fw-semibold text-muted text-uppercase mb-2">Quick Actions</div>
      <div class="d-flex flex-wrap gap-1">
        <button class="btn btn-sm btn-outline-light py-1 px-2 fs-8" (click)="createInvoice()" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <i class="bi bi-receipt me-1 text-primary"></i>Invoice
        </button>
        <button class="btn btn-sm btn-outline-light py-1 px-2 fs-8" (click)="createExpense()" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <i class="bi bi-cash-stack me-1 text-danger"></i>Expense
        </button>
        <button class="btn btn-sm btn-outline-light py-1 px-2 fs-8" (click)="newCustomer()" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <i class="bi bi-person-plus me-1 text-info"></i>Customer
        </button>
        <button class="btn btn-sm btn-outline-light py-1 px-2 fs-8" (click)="newWorksheet()" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <i class="bi bi-clipboard-plus me-1 text-warning"></i>Worksheet
        </button>
      </div>
    </div>

    <!-- Mobile Search -->
    <div class="erp-mobile-search p-3 pb-2">
      <ng-select
        class="w-100"
        [items]="contacts"
        bindLabel="name"
        bindValue="contact_id"
        placeholder="Search contacts…"
        [searchable]="true"
        [searchFn]="customSearchFn"
        (change)="onContactChange($event)"
      >
        <ng-template ng-label-tmp let-item="item">{{ item.name }}</ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="fw-semibold">{{ item.name }}</div>
          <div class="text-muted fs-8">{{ item.phone || 'No Phone' }}</div>
        </ng-template>
      </ng-select>
    </div>

    <!-- Mobile Nav Links -->
    <nav class="erp-mobile-nav p-3 pt-0">
      <div class="fs-8 fw-semibold text-muted text-uppercase mb-1">Navigation</div>
      <a routerLink="/" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-speedometer2 me-2"></i>Dashboard
      </a>
      <a routerLink="/dashboard/supervisor" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-graph-up me-2"></i>Supervisor Desk
      </a>
      <a routerLink="/order/invoice/view-all" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-receipt me-2"></i>Sales & Invoices
      </a>
      <a routerLink="/order/purchase/view-all" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-bag-check me-2"></i>Purchases
      </a>
      <a routerLink="/accounts/transaction/view-all" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-cash-stack me-2"></i>Payments & Transactions
      </a>
      <a routerLink="/accounts/wallet" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-wallet2 me-2"></i>Wallets Ledger
      </a>
      <a routerLink="/work" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-hammer me-2"></i>Production & Work
      </a>
      <a routerLink="/hrm/customer/view-all" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-people me-2"></i>Contacts & Workforce
      </a>
      <a routerLink="/hrm/reminders" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-bell me-2"></i>Reminders Hub
      </a>
      @if (isAdmin) {
        <a routerLink="/user-management" data-bs-toggle="collapse" data-bs-target="#navbarContent">
          <i class="bi bi-shield-lock me-2 text-warning"></i>User Directory & Access
        </a>
      }
      <a routerLink="/manage/tags/view-all" data-bs-toggle="collapse" data-bs-target="#navbarContent">
        <i class="bi bi-tags me-2"></i>Tag Management
      </a>
    </nav>
  </div>
</nav>
